/**
* Before and After Slider JS
* -----------------------------------------------------------------------------
*
* All the JS for the Before and After Slider component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'before-and-after-slider',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      // gsap.registerPlugin( ScrollTrigger );
      $( '.before-after-slider-outer' ).slick( {
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        draggable: false,
        adaptiveHeight: true,
        appendArrows: $( '.before-after-nav-wrapper' ),
        prevArrow: '<button type="button" class=""><svg class="icon icon-left-arrow"><use xlink:href="#icon-left-arrow"></use></svg> <span class="sr-only">Previous case</span></button>',
        nextArrow: '<button type="button" class=""><span class="sr-only">Next case</span> <svg class="icon icon-right-arrow"><use xlink:href="#icon-right-arrow"></use></svg></button>',
        fade: true,
        cssEase: 'linear',
      } );

      $( '.before-and-after-slider .image-wrapper .dragger' ).on( 'mousedown touchstart', function() {
        $( this ).closest( '.comparison-slider' ).on( 'mousemove touchmove', function( e ) {
          const offset = $( this ).offset();
          const pos = ( ( e.pageX - offset.left ) / $( this ).find( '.slider-img--2' ).width() ) * 100;
          $( this ).find( '.slider-img--1' ).css( 'clip-path', 'polygon(0% 0%, ' + pos + '% 0%, ' + pos + '% 100%, 0% 100%)' );
          $( this ).find( '.slider-img--2' ).css( 'clip-path', 'polygon(' + pos + '% 0%, 100% 0%, 100% 100%, ' + pos + '% 100%)' );
          $( this ).find( '.dragger' ).css( 'left', e.pageX - offset.left );
        } );
      } ).on( 'mouseup touchend', function() {
        $( '.before-and-after-slider .image-wrapper .comparison-slider, .image-wrapper .comparison-slider *' ).off( 'mousemove touchmove' );
      } );

      $( '.before-and-after-slider' ).each( function( key, val ) {
        $( val ).find( '.prev-slide' ).on( 'click', function() {
          $( val ).find( '.before-after-slider-outer' ).slick( 'slickPrev' );
        } );

        $( val ).find( '.next-slide' ).on( 'click', function() {
          $( val ).find( '.before-after-slider-outer' ).slick( 'slickNext' );
        } );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'before-and-after-slider', COMPONENT );
} )( app );
